import { render } from "./RadixDeviceInput.vue?vue&type=template&id=524c833e"
import script from "./RadixDeviceInput.vue?vue&type=script&lang=js"
export * from "./RadixDeviceInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__